import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row mb-2" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, " Group Name ", -1);
const _hoisted_4 = { class: "col-8" };
const _hoisted_5 = {
    key: 0,
    class: "row mb-2"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, " Number of participants ", -1);
const _hoisted_7 = { class: "col-8" };
const _hoisted_8 = { class: "row mb-2" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, " Formule ", -1);
const _hoisted_10 = { class: "col-8" };
const _hoisted_11 = {
    key: 1,
    class: "row mb-2"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, " Language ", -1);
const _hoisted_13 = { class: "col-8" };
const _hoisted_14 = {
    key: 0,
    class: "row"
};
const _hoisted_15 = { class: "col d-flex justify-content-end" };
const _hoisted_16 = /*#__PURE__*/ _createTextVNode(" Are you sure? ");
import Selector from '@/components/UI/Selector/Selector.vue';
import { BeatoutLanguage } from '@/types/translations';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useGroups } from '@/compositions/useGroups';
import ModalBox from '../UI/ModalBox/ModalBox.vue';
import Alert from '../UI/Alert/Alert.vue';
import Button from '../UI/Button/Button.vue';
import Icon from '../UI/Icon/Icon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        group: null,
        mode: null,
        groupId: null
    },
    emits: ['close'],
    setup(__props, { emit }) {
        const props = __props;
        const toast = useToast();
        const { deleteGroup } = useGroups();
        const language = ref(BeatoutLanguage.Dutch);
        const requestDelete = ref(false);
        const languages = Object.values(BeatoutLanguage).map((language) => ({
            text: language,
            value: language
        }));
        const beatoutPackages = [
            { text: 'Beat Out! 5', value: 5 },
            { text: 'Beat Out! 7', value: 7 },
            { text: 'Beat Out! 10', value: 10 },
            { text: '-------', value: 1 },
            { text: 'Beat Out! 3', value: 3 },
            { text: 'Beat Out! 4', value: 4 },
            { text: 'Beat Out! 6', value: 6 },
            { text: 'Beat Out! 8', value: 8 },
            { text: 'Beat Out! 9', value: 9 },
        ];
        async function sureDeleteGroup() {
            if (!props.groupId) {
                return;
            }
            console.log('Deleting group', props.groupId);
            try {
                await deleteGroup(props.groupId);
                toast.success(`Group has been deleted`);
                requestDelete.value = false;
                emit('close');
            }
            catch (error) {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
            }
        }
        return (_ctx, _cache) => {
            const _component_Card = _resolveComponent("Card");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_Card, {
                    title: "Group",
                    class: "mb-2"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _hoisted_3,
                                _createElementVNode("div", _hoisted_4, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((props.group.name) = $event)),
                                        type: "text",
                                        "data-cy": "editgroup_name"
                                    }, null, 512), [
                                        [_vModelText, props.group.name]
                                    ])
                                ])
                            ]),
                            (__props.mode === 'create')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createElementVNode("div", _hoisted_7, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((props.group.num_participants) = $event)),
                                            type: "number",
                                            "data-cy": "editgroup_num_participants"
                                        }, null, 512), [
                                            [_vModelText, props.group.num_participants]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(Selector, {
                                        modelValue: props.group.num_slots,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((props.group.num_slots) = $event)),
                                        options: beatoutPackages,
                                        "default-text": 'Custom package'
                                    }, null, 8, ["modelValue"])
                                ])
                            ]),
                            (__props.mode === 'create')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createElementVNode("div", _hoisted_13, [
                                        _createVNode(Selector, {
                                            modelValue: language.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((language).value = $event)),
                                            options: _unref(languages)
                                        }, null, 8, ["modelValue", "options"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (__props.mode === 'edit')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(Button, {
                                        variant: "danger",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (requestDelete.value = true))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(Icon, { name: "trash" })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (requestDelete.value)
                    ? (_openBlock(), _createBlock(ModalBox, {
                        key: 0,
                        submitButtonTitle: "Delete",
                        onSubmit: sureDeleteGroup,
                        onClose: _cache[5] || (_cache[5] = ($event) => (requestDelete.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(Alert, {
                                show: "",
                                variant: "danger"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_16
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
